// Resolve both UUID and legacy employee-code manager references.
export function getOrgRelationships(employees, hierarchy, selectedId) {
  const active = employees.filter(emp => emp.is_active !== false && emp.employment_status !== 'terminated');
  const byId = new Map(active.map(emp => [emp.id, emp]));
  const byCode = new Map(active.filter(emp => emp.employee_code).map(emp => [emp.employee_code, emp]));
  const managerOf = emp => {
    const ref = hierarchy[emp.id] || (emp.employee_code && hierarchy[emp.employee_code]);
    return { ref, employee: byId.get(ref) || byCode.get(ref) };
  };
  const selected = byId.get(selectedId);
  if (!selected) return null;
  const ancestors = [];
  const visited = new Set([selected.id]);
  let current = selected;
  let issue = '';
  while (current) {
    const manager = managerOf(current);
    if (!manager.ref) break;
    if (!manager.employee) {
      issue = 'A reporting manager is unavailable. The chain ends at the last available employee.';
      break;
    }
    if (visited.has(manager.employee.id)) {
      issue = 'A circular reporting relationship needs correction. The repeated link is not shown.';
      break;
    }
    visited.add(manager.employee.id);
    ancestors.unshift(manager.employee);
    current = manager.employee;
  }
  const directReports = active.filter(emp => emp.id !== selected.id && !visited.has(emp.id) && managerOf(emp).employee?.id === selected.id)
    .sort((a, b) => (a.name || '').localeCompare(b.name || ''));
  let root = { ...selected, children: directReports.map(emp => ({ ...emp, children: [] })) };
  for (let index = ancestors.length - 1; index >= 0; index--) {
    root = { ...ancestors[index], children: [root] };
  }
  return { selected, ancestors, directReports, roots: [root], issue };
}
